<div class="d-flex flex-wrap w-100">
	<div class="display-14 my-auto">
		<div>Customize <i>Order Type</i> specific settings for all FocusKitchen displays.</div>
		<div>
			You can change the Order Header color as well as the displayed <i>Order Type</i> name based on if the station is an Expo station or a Line station.
		</div>
	</div>
	<div class="ms-auto my-auto">
		<app-record-control-footer
			[hideAdd]="false"
			[hideCancel]="true"
			[hideDelete]="true"
			[hideSave]="true"
			(onAddChange)="addOrderTypeSetting()"
		></app-record-control-footer>
	</div>
</div>
<div>
	<p-divider></p-divider>
	<ng-container *ngFor="let ot of kitchenDevicePreferences.orderTypeSettings; let idx = index">
		<div class="p-grid">
			<div class="p-col-12 p-md-3 mt-3">
				<span class="p-float-label">
					<p-dropdown
						#orderTypeSelectInput
						[options]="posOrderTypes"
						optionLabel="Name"
						optionValue="Name"
						name="orderTypeSelectInput"
						[(ngModel)]="ot.orderTypeName"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(posOrderTypes)"
						(onChange)="changesToSaveChange.emit(true)"
					></p-dropdown>
					<label for="orderTypeSelectInput">Order Type</label>
				</span>
			</div>
			<div class="p-col-12 p-md-3 mt-3">
				<div class="d-flex w-100">
					<div class="my-auto">
						<p-colorPicker (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="ot.color"> </p-colorPicker>
					</div>
					<div class="my-auto w-100">
						<span class="p-float-label w-100">
							<input pInputText (ngModelChange)="changesToSaveChange.emit(true)" class="mx-2 w-100" id="siteBgColor" [(ngModel)]="ot.color" />
							<label for="headerBgColor">Header Color</label>
						</span>
					</div>
				</div>
			</div>
			<div class="p-col-12 p-md-2 mt-3">
				<div class="mt-2">
					<span class="p-float-label">
						<input
							pInputText
							#orderTypeExpoNameInput
							name="orderTypeExpoNameInput"
							type="text"
							[(ngModel)]="ot.expoOrderTypeName"
							(ngModelChange)="changesToSaveChange.emit(true)"
							class="w-100"
						/>
						<label for="orderTypeExpoNameInput">Expo Station Name</label>
					</span>
				</div>
			</div>
			<div class="p-col-12 p-md-2 mt-3">
				<div class="mt-2">
					<span class="p-float-label">
						<input
							pInputText
							#orderTypeLineNameInput
							name="orderTypeLineNameInput"
							type="text"
							[(ngModel)]="ot.lineOrderTypeName"
							(ngModelChange)="changesToSaveChange.emit(true)"
							class="w-100"
						/>
						<label for="orderTypeLineNameInput">Line Station Name</label>
					</span>
				</div>
			</div>
			<div class="p-col-12 p-md-2 mt-3">
				<app-record-control-footer
					[hideAdd]="true"
					[hideCancel]="true"
					[hideDelete]="false"
					[hideSave]="true"
					(onDeleteChange)="deleteOrderTypeSetting(idx)"
				></app-record-control-footer>
			</div>
		</div>
	</ng-container>
</div>
